import type { CaseOwner } from '../types/patterns';

/** Soft brand-leaning gradients, picked deterministically from the owner name. */
const AVATAR_GRADIENTS = [
  'from-cyan-400 to-sky-500',
  'from-sky-400 to-indigo-500',
  'from-violet-400 to-fuchsia-500',
  'from-rose-400 to-orange-400',
  'from-emerald-400 to-teal-500',
  'from-amber-400 to-rose-400',
];

function gradientForOwner(name: string): string {
  const hash = Array.from(name).reduce(
    (accumulator, character) => accumulator + character.charCodeAt(0),
    0
  );
  return (
    AVATAR_GRADIENTS[hash % AVATAR_GRADIENTS.length] ??
    'from-cyan-400 to-sky-500'
  );
}

interface OwnerAvatarProps {
  owner: CaseOwner;
  className?: string;
}

/** Initials avatar - no external image assets, deterministic color per owner. */
export function OwnerAvatar({ owner, className = '' }: OwnerAvatarProps) {
  return (
    <span
      title={owner.name}
      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gradient-to-br text-[11px] font-semibold text-white shadow-sm ring-2 ring-white ${gradientForOwner(
        owner.name
      )} ${className}`}
    >
      {owner.initials}
    </span>
  );
}
